import {useEffect} from 'react'
import AditionalCamp from '../../../../../../components/UI/Form/aditionalCamp'
import {
  InputNumberWrapper,
  InputTextWrapper,
  SelectWrapper,
} from '../../../../../../components/UI/Form/Input'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useSites} from '../../../../hooks/central/useSites'
import {useFormContext} from 'react-hook-form'
import {useParameters} from '../../../../hooks/central/useParameters'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {getModuleByIdService} from '../../../../../hoteleria/services/module.service'
import {formatDateType2} from '../../../../../../util/dates'

export const TypeOfBuildingForm = () => {
  const {setError, setValue, watch} = useFormContext()

  const {currentTabItem} = useLimpieza()
  const {getCompanies, companies, clearCompanies} = useCompanies()
  const {getClients, clients, clearClients} = useClients()
  const {getSites, sites, clearSites} = useSites()
  const {getCampaments, campaments, clearCampaments} = useCampaments()
  const {
    getStatusModules,
    getTypeModules,
    getGenres,
    getTypeBathrooms,
    getTypeBuildings,
    getTypePreAsignations,
    statusModules,
    typeModules,
    genres,
    typeBathrooms,
    typeBuildings,
    typePreAsignations,
  } = useParameters()

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    getTypeModules({pageNumber: 1, size: 200, tableName: 'TipoModulo'})
    getStatusModules({pageNumber: 1, size: 200, tableName: 'EstadoModulo'})
    getGenres({pageNumber: 1, size: 200, tableName: 'Sexo'})
    getTypeBathrooms({pageNumber: 1, size: 200, tableName: 'TipoBanio'})
    getTypeBuildings({pageNumber: 1, size: 200, tableName: 'TipoEdificacion'})
    getTypePreAsignations({pageNumber: 1, size: 200, tableName: 'TipoPreAsignacion'})
    return () => {
      clearCompanies()
      clearClients()
      clearSites()
      clearCampaments()
    }
  }, [])

  useEffect(() => {
    if (companies.length === 1) {
      setValue('CompaniaId', companies[0].value)
      setError('CompaniaId', {})
      getClients({isCombo: true, companiaId: companies[0].value}, 1)
    }
  }, [companies])

  useEffect(() => {
    if (clients.length === 1) {
      setValue('ClienteId', clients[0].value)
      setError('ClienteId', {})
      getSites({isCombo: true, clienteId: clients[0].value}, 1)
    }
  }, [clients])

  useEffect(() => {
    if (sites.length === 1) {
      setValue('SiteId', sites[0].value)
      setError('SiteId', {})
      getCampaments({isCombo: true, siteId: sites[0].value}, 1)
    }
  }, [sites])

  useEffect(() => {
    if (campaments.length === 1) {
      setValue('CampamentoId', campaments[0].value)
      setError('CampamentoId', {})
    }
  }, [campaments])

  useEffect(() => {
    if (statusModules.length > 0) {
      const defaultStatus = statusModules.find((item: any) => item.label === 'DISPONIBLE')?.value
      if (!currentTabItem.idToEdit) {
        setValue('EstadoModuloId', defaultStatus)
      }
    }
  }, [statusModules])

  useEffect(() => {
    if (typePreAsignations.length > 0) {
      const defatultPreasignation = typePreAsignations.find(
        (item: any) => item.label === 'NO PERMANENTE',
      )?.value
      if (!currentTabItem.idToEdit) {
        setValue('TipoPreAsignacionId', defatultPreasignation)
      }
    }
  }, [typePreAsignations])

  const getModuleById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getModuleByIdService(idToEdit)
        if (data) {
          const {
            CampamentoId,
            SiteId,
            TipoModuloId,
            Codigo,
            EstadoModuloId,
            TipoPreAsignacionId,
            SexoId,
            TipoBanioId,
            // NivelId,
            NroPisos,
            NroHabitaciones,
            PrioridadAsignacion,
            CompaniaId,
            ClienteId,
            Campoadicionaltxt1,
            Campoadicionaltxt2,
            Campoadicionaltxt3,
            Campoadicionaltxt4,
            Campoadicionaltxt5,
            Campoadicionalnum1,
            Campoadicionalnum2,
            Campoadicionalnum3,
            CampoadicionalFec1,
            CampoadicionalFec2,
            TipoEdificacionId,
          } = data

          setValue('Id', idToEdit)
          setValue('CampamentoId', CampamentoId)
          setValue('CompaniaId', CompaniaId)
          setValue('ClienteId', ClienteId)
          setValue('SiteId', SiteId)
          setValue('TipoModuloId', TipoModuloId)
          setValue('Codigo', Codigo)
          setValue('EstadoModuloId', EstadoModuloId)
          setValue('TipoPreAsignacionId', TipoPreAsignacionId)
          setValue('SexoId', SexoId)
          setValue('TipoBanioId', TipoBanioId)
          setValue('TipoEdificacionId', TipoEdificacionId)
          setValue('NroPisos', NroPisos)
          setValue('NroHabitaciones', NroHabitaciones)
          setValue('PrioridadAsignacion', PrioridadAsignacion)
          setValue('Campoadicionaltxt1', Campoadicionaltxt1)
          setValue('Campoadicionaltxt2', Campoadicionaltxt2)
          setValue('Campoadicionaltxt3', Campoadicionaltxt3)
          setValue('Campoadicionaltxt4', Campoadicionaltxt4)
          setValue('Campoadicionaltxt5', Campoadicionaltxt5)
          setValue('Campoadicionalnum1', Campoadicionalnum1)
          setValue('Campoadicionalnum2', Campoadicionalnum2)
          setValue('Campoadicionalnum3', Campoadicionalnum3)
          setValue('CampoadicionalFec1', formatDateType2(CampoadicionalFec1))
          setValue('CampoadicionalFec2', formatDateType2(CampoadicionalFec2))
          getClients({isCombo: true, companiaId: CompaniaId}, 1)
          getSites({isCombo: true, clienteId: ClienteId}, 1)
          getCampaments({isCombo: true, siteId: SiteId}, 1)
        }
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getModuleById()
    }
  }, [currentTabItem.idToEdit])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    clearSites()
    setValue('CampamentoId', '')
    clearCampaments()
    setError('CompaniaId', {})
    clearClients()
    getClients({isCombo: true, companiaId: value}, 1)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    clearSites()
    clearCampaments()
    setError('ClienteId', {})
    getSites({isCombo: true, clienteId: value}, 1)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    clearCampaments()
    getCampaments({isCombo: true, siteId: value}, 1)
  }

  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <ContentForm isEdit={isDisabled} title='Datos de Tipo de Edificación'>
      <div className='sdx_form card p-4'>
        <div className='d-flex row'>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Compañia'
              name='CompaniaId'
              data={companies}
              onChangeValue={handleCompanyChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Cliente'
              name='ClienteId'
              data={clients}
              onChangeValue={handleClientChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Site'
              name='SiteId'
              data={sites}
              onChangeValue={handleSiteChange}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper labelText='Campamento' name='CampamentoId' data={campaments} required />
          </div>
        </div>
        <div className='d-flex row'>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Nomenclatura de Módulo'
              name='Codigo'
              textPlaceholder='Escribe el Codigo'
              type='ticketNumber'
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Tipo de Módulo'
              name='TipoModuloId'
              data={typeModules}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper labelText='Estado' name='EstadoModuloId' data={statusModules} required />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper labelText='Sexo' name='SexoId' data={genres} required />
          </div>
        </div>
        <div className='d-flex row'>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Tipo de Baño'
              name='TipoBanioId'
              data={typeBathrooms}
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputNumberWrapper
              labelText='Pisos'
              name='NroPisos'
              textPlaceholder='Escribe el Numero de Pisos'
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputNumberWrapper
              labelText='Nro de Habitaciones'
              name='NroHabitaciones'
              textPlaceholder='Escribe el Numero de Habitaciones'
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <InputNumberWrapper
              labelText='Nro de Secuencia de Asignación'
              name='PrioridadAsignacion'
              textPlaceholder='Escribe el Numero de Habitaciones'
              required
            />
          </div>
          <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
            <SelectWrapper
              labelText='Tipo de Edificación'
              name='TipoEdificacionId'
              data={typeBuildings}
              required
            />
          </div>
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
        <hr className='divider' />
        <AditionalCamp module='limpieza' />
      </div>
    </ContentForm>
  )
}
